export const sendMessage = (socket,payload,users_id) => {
    if(socket && socket.readyState == WebSocket.OPEN) {
        socket.send(JSON.stringify({...payload,users_id:users_id}))
        console.log("Message sent to WebSocket")
    } else {
        console.log("WebSocket disconnected or unavailable.")
    }
};

/**
 * truncates the given text to the specified length and adds '...' if necessary.
 * @param {string} text - the text to truncate
 * @param {number} maxLength = the max length of the truncated text
 * @param {boolean} {addEllipsis=true} - whether to add '...' if truncate occurs
 * @returns {string} - the truncted text
 */
export const truncateText = (text, maxLength, addEllipsis = true) => {
    if (text.length <= maxLength) {
        return text;
    }
    const truncated = text.slice(0, maxLength)
    return addEllipsis ? `${truncated}...` : truncated
}

export const handleSocketMessage = (data, setLatestActivity, hasResponse, setHasResponse) => {
    const response = typeof data === 'string' ? JSON.parse(data) : data

    if(!Array.isArray(response) || response.length === 0) {
        setLatestActivity([])
        setHasResponse({has: false, response:null})
        return
    }

    const extractedData = response.map(item => {
        try {
            const botData = JSON.parse(item.bot)
            return {
                contextuse: botData.contextuse,
                reason: botData.reason,
            };
        } catch (err) {
            console.error("Error parsing response data", err, item)
            return null
        }
    }).filter(Boolean) // Remove any nulls from failed parses

    setLatestActivity(extractedData)
    // const latest = response[response.length -1]
    // let latestBot
    // try {
    //     latestBot = JSON.parse(latest.bot)
    // } catch (err) {
    //     console.error("Error parsing latest response data", err, latest)
    //     latestBot = null
    // }
    setHasResponse({...hasResponse, has:true, response: response})
}

export const reconnectWebSocket = (connectPromptWebSocket, showLoader) => {
    console.log("WebSocket closed, attempting to reconnect")
    connectPromptWebSocket()
    showLoader(false)
}
